import { render, staticRenderFns } from "./C_Ongoing_Quest_CardsRiddles.vue?vue&type=template&id=6f1e2bc0&scoped=true&"
import script from "./C_Ongoing_Quest_CardsRiddles.vue?vue&type=script&lang=js&"
export * from "./C_Ongoing_Quest_CardsRiddles.vue?vue&type=script&lang=js&"
import style0 from "./C_Ongoing_Quest_CardsRiddles.vue?vue&type=style&index=0&id=6f1e2bc0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1e2bc0",
  null
  
)

export default component.exports